document.addEventListener("DOMContentLoaded", () => {
  const swiper = new Swiper(".three-column-cards__swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 10000,
    },
    pagination: {
      el: ".three-column-cards__dots",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 36,
      },
    },
  });
});

const triggerModal = ( target ) => {
  const modal = document.getElementById( target ),
      modalBody = modal.querySelector('.three-column-cards__modal-body'),
      wrapper = document.querySelector('.three-column-cards__modal-wrapper');

  /**
   * Set the modal margins.
   * @type {string}
   */
  modal.style.display = 'block';
  modalBody.style.marginTop = ((modalBody.offsetHeight / 2) * -1) + 'px';

  /**
   * Disable scroll if the modal is open.
   */
  wrapper.addEventListener('wheel', (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  });
}

const closeModal = ( target ) => {
  const modal = document.getElementById( target )
  modal.style.display = 'none';
}
